var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSleepCoach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 101,
    viewBox: "0 0 71 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6826_2872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5979 53.4874H55.7771V28.9368C55.7771 17.8177 46.6799 8.77145 35.4982 8.77145C24.3165 8.77145 15.2193 17.8177 15.2193 28.9368V53.4874H6.39844V28.9368C6.39844 21.2073 9.42544 13.9409 14.9216 8.47548C20.4178 3.01006 27.7252 0 35.4982 0C43.2712 0 50.5786 3.01006 56.0747 8.47548C61.5709 13.9409 64.5979 21.2073 64.5979 28.9368V53.4874Z",
    fill: "#00374C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3517 101H6.64828C2.97639 101 0 98.04 0 94.3886V51.7234C0 48.072 2.97639 45.1123 6.64828 45.1123H64.3527C68.0246 45.1123 71.001 48.072 71.001 51.7234V94.3886C71 98.04 68.0236 101 64.3517 101Z",
    fill: "url(#paint0_linear_6826_2872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6484 73.0087C40.0629 72.1087 41.7556 69.7399 41.621 66.9946C41.4691 63.8788 38.9271 61.355 35.7938 61.209C32.2737 61.0449 29.3672 63.8345 29.3672 67.2986C29.3672 69.913 31.0224 72.1419 33.3479 73.0087L31.2188 78.8375C30.1406 81.7902 32.3395 84.91 35.4981 84.91C38.6568 84.91 40.8556 81.7892 39.7775 78.8375L37.6484 73.0087Z",
    fill: "#00374C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14581 94.3887V51.7224C9.14581 48.0711 12.1222 45.1113 15.7941 45.1113H6.64828C2.97639 45.1123 0 48.0721 0 51.7224V94.3887C0 98.04 2.97639 101 6.64828 101H15.7941C12.1222 101 9.14581 98.04 9.14581 94.3887Z",
    fill: "url(#paint1_linear_6826_2872)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6826_2872",
    x1: 6.42195,
    y1: 44.1406,
    x2: 67.3582,
    y2: 105.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6826_2872",
    x1: 7.89707,
    y1: 45.5959,
    x2: 7.89707,
    y2: 101.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6826_2872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSleepCoach);
export default __webpack_public_path__ + "static/media/LockSleepCoach.278435a09c81ea88bd95dfe46741d818.svg";
export { ForwardRef as ReactComponent };